import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import CorrectionType from "./actionTypes"

import moment from "moment"
import correctionAPI from "helpers/correction_backend_helper"
import CorrectionAction from "./actions"

function* fetchListOnPage({ payload }) {
  yield put(
    CorrectionAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(correctionAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      CorrectionAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      CorrectionAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    CorrectionAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(correctionAPI.getDetail, payload.id)

    action(data)
    yield put(
      CorrectionAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      CorrectionAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    CorrectionAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    payload.closingDate = moment(payload.closingDate).format("YYYY-MM-DD")
    payload.paymentDate = moment(payload.paymentDate).format("YYYY-MM-DD")
    let { data } = yield call(correctionAPI.postData, payload)

    yield put(
      CorrectionAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      CorrectionAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    CorrectionAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(correctionAPI.putData, payload)
    yield put(
      CorrectionAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      CorrectionAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchList({ payload }) {
  yield put(
    CorrectionAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(correctionAPI.getList)
    yield put(
      CorrectionAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      CorrectionAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* correctionSaga() {
  yield takeEvery(CorrectionType.GET_CORRECTION_PAGES, fetchListOnPage)
  yield takeEvery(CorrectionType.GET_DETAIL_CORRECTION_BY_ID, fetchDetail)
  yield takeEvery(CorrectionType.POST_CORRECTION, fetchPostData)
  yield takeEvery(CorrectionType.PUT_CORRECTION, fetchPutData)
  yield takeEvery(CorrectionType.GET_CORRECTION_LIST, fetchList)
}

export default correctionSaga
